import React from 'react';
import Select from 'react-select';

const AlimentacionCongreso = ({ 
  formData, 
  handleSelectChange, 
  cenaViernesOptions, 
  almuerzoSabadoOptions, 
  cenaSabadoOptions 
}) => {
  return (
    <div className="alimentacion-congreso">
      <h2 style={{
        fontSize: '1.5rem',
        fontWeight: '600',
        color: '#1f2937',
        marginBottom: '1rem',
        display: 'flex',
        alignItems: 'center'
      }}>
        <span style={{
          backgroundColor: '#ddd6fe',
          color: '#7c3aed',
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: '0.75rem',
          fontWeight: 'bold',
          fontSize: '0.875rem'
        }}>5</span>
        Alimentación Congreso
      </h2>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
        {/* Grupo 1: Cena Viernes y Almuerzo Sábado */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '3rem'
        }}>
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', fontSize: '1rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>
              Cena del viernes (15 de mayo)
            </label>
            <Select
              value={cenaViernesOptions.find(option => option.label === formData.alimentacionCenaViernes)}
              onChange={(selectedOption) => handleSelectChange(selectedOption, 'alimentacionCenaViernes')}
              options={cenaViernesOptions}
              placeholder="Selecciona una opción"
              isClearable
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: '52px',
                  fontSize: '16px',
                  borderColor: '#d1d5db',
                  '&:hover': { borderColor: '#9ca3af' }
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected ? '#3A7D5C' : 'white',
                  color: state.isSelected ? 'white' : '#1f2937',
                  fontWeight: state.isSelected ? 500 : 400,
                  '&:hover': {
                    backgroundColor: state.isSelected ? '#2d6147' : '#e8f5e8',
                    color: state.isSelected ? 'white' : '#1f2937'
                  }
                })
              }}
            />
          </div>

          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', fontSize: '1rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>
              Almuerzo del sábado (16 de mayo)
            </label>
            <Select
              value={almuerzoSabadoOptions.find(option => option.label === formData.alimentacionAlmuerzoSabado)}
              onChange={(selectedOption) => handleSelectChange(selectedOption, 'alimentacionAlmuerzoSabado')}
              options={almuerzoSabadoOptions}
              placeholder="Selecciona una opción"
              isClearable
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: '52px',
                  fontSize: '16px',
                  borderColor: '#d1d5db',
                  '&:hover': { borderColor: '#9ca3af' }
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected ? '#3A7D5C' : 'white',
                  color: state.isSelected ? 'white' : '#1f2937',
                  fontWeight: state.isSelected ? 500 : 400,
                  '&:hover': {
                    backgroundColor: state.isSelected ? '#2d6147' : '#e8f5e8',
                    color: state.isSelected ? 'white' : '#1f2937'
                  }
                })
              }}
            />
          </div>
        </div>

        {/* Grupo 2: Cena Sábado */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '3rem'
        }}>
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', fontSize: '1rem', fontWeight: '500', color: '#374151', marginBottom: '0.5rem' }}>
              Cena del sábado (16 de mayo)
            </label>
            <Select
              value={cenaSabadoOptions.find(option => option.label === formData.alimentacionCenaSabado)}
              onChange={(selectedOption) => handleSelectChange(selectedOption, 'alimentacionCenaSabado')}
              options={cenaSabadoOptions}
              placeholder="Selecciona una opción"
              isClearable
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: '52px',
                  fontSize: '16px',
                  borderColor: '#d1d5db',
                  '&:hover': { borderColor: '#9ca3af' }
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected ? '#3A7D5C' : 'white',
                  color: state.isSelected ? 'white' : '#1f2937',
                  fontWeight: state.isSelected ? 500 : 400,
                  '&:hover': {
                    backgroundColor: state.isSelected ? '#2d6147' : '#e8f5e8',
                    color: state.isSelected ? 'white' : '#1f2937'
                  }
                })
              }}
            />
          </div>

          <div style={{ marginBottom: '1rem' }}></div>
        </div>
      </div>
    </div>
  );
};

export default AlimentacionCongreso;
